import { memo, ReactElement } from 'react';
import { Accordion } from '@/common/ui/containers/Accordion/Accordion';
import * as S from './VActivityTabs.styles';
import { IAccordionTab } from '@/common/ui';

type VActivityTabsProps = {
    tabs: IAccordionTab[];
    handleClickOnTab: (value: number) => void;
    indexOpen: number | null;
};

const VActivityTabsContainer = ({
    tabs,
    handleClickOnTab,
    indexOpen,
}: VActivityTabsProps): ReactElement => {
    return (
        <S.VActivityTabsContainer>
            <Accordion
                tabs={tabs}
                handleClickOnTab={handleClickOnTab}
                indexOpen={indexOpen}
                withStars
            />
        </S.VActivityTabsContainer>
    );
};

export const VActivityTabs = memo(VActivityTabsContainer);
